import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=97586ae2&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=97586ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97586ae2",
  null
  
)

/* custom blocks */
import block0 from "@/lang/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fref133%2Fpcnweb%2Ffrontend%2Fsrc%2Fviews%2FHome.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./Home.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports